import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as globals from '@reusable/services/globals';

@Injectable()
export class PackagesCustomerService {
  responseData: any;
  handleError: any;

  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}
  userPackages() {
    return this.httpClient.get(`${globals.domain}/customer/packages/list/sortBy--createdAt/30/1`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  userPackageStatus() {
    return this.httpClient
      .get(`${globals.domain}/customer/packages/list/sortBy--createdAt/30/1?status=current`, this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }
}